import * as React from "react";

function SvgMail(props) {
  return (
    <svg
      viewBox="0 0 1000 1000"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <path d="M1000 0H0v1000h1000V0zM100 409.393c43.595 36.619 149.797 123.06 246.512 180.184 58.655 34.638 114.724 57.802 153.488 57.802 38.764 0 94.833-23.164 153.488-57.802C750.203 532.453 856.405 446.012 900 409.393v263.658c0 40.934-33.231 74.165-74.165 74.165h-651.67c-40.934 0-74.165-33.231-74.165-74.165V409.393zm0-81.78v-.664c0-40.934 33.231-74.165 74.165-74.165h651.67c40.934 0 74.165 33.231 74.165 74.165v.664l-20.366 17.79s-136.49 119.3-257.639 190.85c-47.042 27.786-90.904 49.202-121.995 49.202-31.091 0-74.953-21.416-121.995-49.202-121.149-71.55-257.639-190.85-257.639-190.85L100 327.613z" />
    </svg>
  );
}

export default SvgMail;